import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert, Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, requiredModule, requiredRole }) {
  const { user, userData, loading, error, hasModuleAccess, isAdmin, signOut } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute] State:', {
    loading,
    hasUser: !!user,
    userEmail: user?.email,
    hasUserData: !!userData,
    error,
    path: location.pathname
  });

  if (loading) {
    console.log('[ProtectedRoute] Still loading...');
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    console.log('[ProtectedRoute] No user - redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (error || !userData) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 3,
        }}
      >
        <Alert severity="error" sx={{ mb: 3, maxWidth: 400 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Access Denied
          </Typography>
          <Typography variant="body2">
            {error || 'You do not have permission to access this application.'}
          </Typography>
        </Alert>
        <Button variant="outlined" onClick={signOut}>
          Sign Out
        </Button>
      </Box>
    );
  }

  if (requiredRole === 'admin' && !isAdmin()) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 3,
        }}
      >
        <Alert severity="warning" sx={{ mb: 3, maxWidth: 400 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Admin Access Required
          </Typography>
          <Typography variant="body2">
            You do not have administrator privileges.
            Please contact an administrator.
          </Typography>
        </Alert>
        <Button variant="outlined" href="/">
          Go to Dashboard
        </Button>
      </Box>
    );
  }

  if (requiredModule && !hasModuleAccess(requiredModule)) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 3,
        }}
      >
        <Alert severity="warning" sx={{ mb: 3, maxWidth: 400 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Module Access Required
          </Typography>
          <Typography variant="body2">
            You do not have access to the {requiredModule.toUpperCase()} module.
            Please contact an administrator.
          </Typography>
        </Alert>
        <Button variant="outlined" href="/">
          Go to Dashboard
        </Button>
      </Box>
    );
  }

  return children;
}

export default ProtectedRoute;
